import React, { useEffect, useState } from "react";
import "./UserManagement.css";
import OverviewCard from "../../components/OverView-Card/overview-card";
import RegistrationTable from "../../components/Registration-table/registration-table";
import PopularBond from "../../components/Popular-bond/Popular-bond";
import RegistartionDetail from "../../components/Registration-details/Registartion-detail";
import RegistartionTableWealth from "../../components/Registration-table-wealth";
import { useNavigate, useNavigation } from "react-router-dom";
import SelectButton from "../../components/SelectButton";
import download from "../../assets/clarity_download-line.png";
import { createColumnHelper } from "@tanstack/react-table";
import moment from "moment";
import ReactTable from "../../components/ReactTable";
import eye from "../../assets/eye.png";
import editBond from "../../assets/editBond.png";
import CustomPagination from "../../components/CustomPagination";
import axios from "axios";
import ReusableModal from "../../components/ReusableModal";
import ToggleButton from "./Toggle";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
export const base_url = process.env.REACT_APP_BASE_URL;
export const api_type = process.env.REACT_APP_API_TYPE;

const toastIds = {
  roleSuccess: "role-success-toast",
  roleError: "role-error-toast",
  statusSuccess: "status-success-toast",
  statusError: "status-error-toast",
};

function RelationshipManagerMain() {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("Role Creation");
  const [selectedOccupation, setSelectedOccupation] = useState("");
  const [selectedReferal, setSelectedReferal] = useState(null);
  const [selectNumber, setSelectedNumber] = useState(null);
  const [searchInput, setSearchInput] = useState("");
  const [searchInputApi, setSearchInputApi] = useState("");
  const [investorDetails, setInvestorDetails] = useState([]);
  // const [page, setPage] = useState(1);
  const [page, setPage] = useState(() => {
    const savedPage = localStorage.getItem("userManagementPage");
    return savedPage ? Number(savedPage) : 1;
  });
  const [total, setTotal] = useState(0);
  const [pageSize, setPazeSize] = useState(0);

  const { userPermissionData } = useSelector((state) => state.userPermission);

  const [error, setError] = useState(null);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalOpenEdit, setIsModalOpenEdit] = useState(false);
  const [newRole, setNewRole] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [managerData, setManagerData] = useState({
    name: "",
    email: "",
    mobileNumber: "",
  });

  const [editManager, setEditManager] = useState({
    id: "",
    name: "",
    email: "",
    mobileNumber: "",
  });
  const optiosStatus = [
    "Pending",
    "Under Review",
    "Approve",
    "Query Raised",
    "Update Request",
  ];

  const optionsRefered = ["All"];

  const optionsShow = ["All", "10", "20", "50"];
  const buttonData = [
    {
      label: "Role Creation",
      path: "/user", // Path for the Investor button
    },
    {
      label: "User Creation",
      path: "/user/creation", // Path for the Wealth Partner button
    },
  ];

  // Function to update multiple values
  const updateRole = (newValues) => {
    setEditManager((prevState) => ({
      ...prevState,
      ...newValues, // Merge new values into the existing state
    }));
    setIsModalOpenEdit(true);
  };

  const columnHelper = createColumnHelper();

  const handleClick = (path, label) => {
    setActiveTab(label);
    navigate(path); // Navigate to the given path
  };

  const handleSelectOccupation = (value) => {
    setSelectedOccupation(value);
  };

  const handleSelectReferal = (value) => {
    setSelectedReferal(value);
  };

  const handleSelectNumber = (value) => {
    setSelectedNumber(value);
  };

  const fetchRelationshipManagersList = async () => {
    const endpoint = `${base_url}/${api_type}/relationshipManager`;

    try {
      const response = await axios.get(endpoint, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`, // Replace 'your-auth-token' with the actual token
        },

        params: {
          page: page,
          search: searchInputApi,
        },
      });
      console.log("role response", response);

      setInvestorDetails(response?.data?.data?.managers);
      console.log("total page", response?.data?.data?.totalPages);
      setPage(response?.data?.data?.currentPage);
      setTotal(response?.data?.data?.totalRecords);
      setPazeSize(response?.data?.data?.totalPages); // Adjust according to your API response structure
    } catch (err) {
      console.error("Failed to fetch pending orders:", err);
      setError(err.message);
    }
  };
  useEffect(() => {
    fetchRelationshipManagersList();
  }, [page, selectedOccupation, searchInputApi]);

  // Add useEffect to handle automatic search when input is cleared
  useEffect(() => {
    if (searchInput === "") {
      setSearchInputApi("");
    }
  }, [searchInput]);

  const openModal = () => setIsModalOpen(true); // Function to open modal
  const closeModal = () => {
    setIsModalOpen(false);
    setNewRole(""); // Clear the input field when modal is closed
  };
  const closeModalEdit = () => setIsModalOpenEdit(false); // Function to close modal

  const toggleStatus = async (id) => {
    const endpoint = `${base_url}/${api_type}/roles/${id}/toggle`;

    try {
      const response = await axios.put(
        endpoint,
        {},
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      if (!toast.isActive(toastIds.statusSuccess)) {
        toast.success("Status Updated", {
          toastId: toastIds.statusSuccess,
          autoClose: 3000,
        });
      }
      fetchRelationshipManagersList();
    } catch (err) {
      if (!toast.isActive(toastIds.statusError)) {
        toast.error(err?.response?.data.message || "Failed to update status", {
          toastId: toastIds.statusError,
          autoClose: 3000,
        });
      }
      console.error("Failed to fetch pending orders:", err);
      setError(err.message);
    }
  };
  const addNewRole = async (type) => {
    const endpoint = `${base_url}/${api_type}/relationshipManager`;
    const endpointEdit = `${base_url}/${api_type}/relationshipManager/${editManager?.id}`;
    const headers = {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    };

    const payload = managerData;
    try {
      const response =
        type === "edit"
          ? await axios.put(
              endpointEdit,
              {
                name: editManager?.name,
                mobileNumber: editManager?.mobileNumber,
                email: editManager?.email,
              },
              { headers }
            )
          : await axios.post(endpoint, payload, { headers });

      // Check if the response indicates a successful operation
      if (response.status === 200 || response.status === 201) {
        // Reset input fields and states
        setNewRole("");
        setEditManager({ email: "", mobileNumber: "", name: "" });

        if (!toast.isActive(toastIds.roleSuccess)) {
          toast.success(
            type === "edit"
              ? "Manager Updated Successfully"
              : "New Manager Added",
            {
              toastId: toastIds.roleSuccess,
              autoClose: 3000,
            }
          );
        }

        fetchRelationshipManagersList();
        setIsModalOpen(false);
        setIsModalOpenEdit(false);
      }
    } catch (err) {
      console.error("Error:", err);
      const errorMessage = err?.response?.data?.message;
      // if (errorMessage?.includes("already exists")) {
      //   const roleName = type === "new" ? newRole : editRole.name;
      //   if (!toast.isActive(toastIds.roleError)) {
      //     toast.error(`Role with name '${roleName}' already exists.`, {
      //       toastId: toastIds.roleError,
      //       autoClose: 3000,
      //     });
      //   }
      // } else {
      //   if (!toast.isActive(toastIds.roleError)) {
      //     toast.error(errorMessage || "Failed to add role", {
      //       toastId: toastIds.roleError,
      //       autoClose: 3000,
      //     });
      //   }
      // }

      toast.error(errorMessage);

      setError(err?.message || "An error occurred");
    }
  };

  const columns = [
    columnHelper.display({
      id: "sn", // A unique ID for the column
      cell: (info) => {
        const status = info?.row?.original?.status;
        const serialNumber = (page - 1) * 10 + info.row.index + 1;
        return (
          <div className="w-[27px] h-[27px] py-1 flex justify-center items-center rounded text-center text-sm">
            {serialNumber}
          </div>
        );
      },
      header: () => <span>Sr. No.</span>,
    }),
    // columnHelper.accessor("id", {
    //   cell: (info) => info.renderValue(),
    //   header: () => <span>Sr. No.</span>,
    // }),
    columnHelper.accessor("name", {
      cell: (info) => info.renderValue(),
      header: () => <span>Name</span>,
    }),
    columnHelper.accessor("mobileNumber", {
      cell: (info) => info.renderValue(),
      header: () => <span>Mobile Number</span>,
    }),
    columnHelper.accessor("email", {
      cell: (info) => info.renderValue(),
      header: () => <span>Email</span>,
    }),

    // columnHelper.accessor("status", {
    //   cell: (info) => {
    //     const status = info?.row;
    //     const roleId = info?.row?.original?.id;
    //     const roleType = info?.row?.original?.name;
    //     console.log("status", status);
    //     console.log("info", info);
    //     return (
    //       <div
    //         className={` w-[50px] h-[27px] py-1 flex justify-center items-center rounded text-center text-sm`}
    //       >
    //         <ToggleButton
    //           value={status}
    //           handleToggleStatus={toggleStatus}
    //           roleId={roleId}
    //           roleType={roleType}
    //         />
    //       </div>
    //     );
    //   },
    //   header: () => <span>Status</span>,
    // }),

    columnHelper.accessor((row) => row, {
      id: "action",
      cell: (info) => {
        const uniqueId = info?.row?.original?.id;
        const name = info?.row?.original?.name;
        console.log("info?.row?.original?", info?.row?.original);
        const email = info?.row?.original?.email;
        const mobileNumber = info?.row?.original?.mobileNumber;
        console.log("investorid", uniqueId);
        // const NavigateScheme = (uniqueId) => {
        //   navigate("/registration/investor/details", {
        //     state: {
        //       uniqueId: uniqueId,
        //     },
        //   });
        // };
        return (
          <>
            {userPermissionData?.user?.edit && (
              <div
                className="flex flex-start "
                onClick={() => {
                  updateRole({
                    id: uniqueId,
                    name: name,
                    email: email,
                    mobileNumber: mobileNumber,
                  });
                }}
              >
                <img src={editBond} alt="Eye " className="cursor-pointer" />
              </div>
            )}
          </>
        );
      },
      header: () => <span>Action</span>,
    }),
  ];
  const handleSearchInput = (value) => {
    setSearchInput(value);
  };
  const handleSearchClick = () => {
    setPage(1);
    setSearchInputApi(searchInput);
  };

  console.log(searchInputApi, "searchinpu");

  const handleRoleNameChange = (e, type, inputType) => {
    const value = e.target.value;
    const InputName = inputType;

    let isValid = false;

    if (InputName === "mobileNumber") {
      // Allow only up to 10 digits
      isValid = /^\d{0,10}$/.test(value);
    } else if (InputName === "email") {
      // Allow any input during typing
      isValid = true;
    } else {
      // For name-like fields: start with a letter, allow letters, spaces, underscores
      isValid = value === "" || /^[A-Za-z][A-Za-z _]*$/.test(value);
    }

    if (isValid) {
      if (type === "new") {
        setManagerData((prev) => ({ ...prev, [InputName]: value }));
      } else if (type === "edit") {
        setEditManager((prevState) => ({
          ...prevState,
          [InputName]: value,
        }));
      }
    }
  };

  return (
    <div className=" mt-[60px] px-4 flex flex-col min-h-[calc(100vh-60px)]">
      {/* <div className="flex flex-wrap justify-center md:justify-start">
        {buttonData.map((button, index) => (
          <button
            key={index}
            className={`w-[135px] text-[14px] px-4 py-2   ${
              activeTab === button.label ? "bg-[#035C98] text-white " : ""
            } ${
              index === 0 ? "rounded-l" : "rounded-r"
            } focus:outline-none focus:ring-2`}
            onClick={() => handleClick(button.path, button.label)} // Navigate on click
          >
            {button.label}
          </button>
        ))}
      </div> */}
      <div className="bg-white px-8 py-2 mt-4 rounded-[10px] border overflow-auto">
        <h1 className="text-[#252C32] text-[24px]">Relationship Managers </h1>
        <div class="">
          <div class="flex flex-wrap justify-between  items-center gap-x-2 py-4 gap-y-4">
            <div className="flex gap-2">
              <div class="flex gap-0.5">
                <input
                  type="text"
                  placeholder="Search by managers"
                  className="rounded-l-[10px] w-[217px]"
                  value={searchInput}
                  onChange={(e) => handleSearchInput(e?.target?.value)}
                />
                <button
                  onClick={handleSearchClick}
                  className=" bg-[#035C98] text-white font-bold py-2 px-4 rounded-r-[8px]"
                >
                  Search
                </button>
              </div>
              {/* <div className="flex items-center">
                <div className="w-[136px]">
                  <SelectButton
                    options={optiosStatus}
                    selectedValue={selectedOccupation}
                    onSelect={handleSelectOccupation}
                  />
                </div>
              </div> */}
            </div>
            {userPermissionData?.user?.addRole && (
              <div class="flex items-center bg-[#035C98] px-4 rounded-[8px]">
                <button
                  class="btn   text-white font-bold  "
                  onClick={openModal}
                >
                  Add New
                </button>
              </div>
            )}
            {/* Modal Component */}
            {isModalOpen && (
              <ReusableModal
                title="Create New Manager"
                content={
                  <>
                    <label>Name</label>

                    <div className="flex mt-2">
                      <input
                        type="text"
                        value={managerData?.name}
                        placeholder="Enter Name"
                        className="w-full h-10 p-2.5 border-none rounded bg-gray-50"
                        onChange={(e) => handleRoleNameChange(e, "new", "name")}
                      />
                    </div>
                    <label>Mobile Number</label>

                    <div className="flex mt-2">
                      <input
                        type="text"
                        value={managerData?.mobileNumber}
                        placeholder="Enter Mobile Number"
                        className="w-full h-10 p-2.5 border-none rounded bg-gray-50"
                        onChange={(e) =>
                          handleRoleNameChange(e, "new", "mobileNumber")
                        }
                      />
                    </div>
                    <label>Email</label>

                    <div className="flex mt-2">
                      <input
                        type="text"
                        value={managerData?.email}
                        placeholder="Enter Email"
                        className="w-full h-10 p-2.5 border-none rounded bg-gray-50"
                        onChange={(e) =>
                          handleRoleNameChange(e, "new", "email")
                        }
                      />
                    </div>
                  </>
                }
                onUpload={() => addNewRole("new")}
                ButtonValue="Create"
                onClose={closeModal} // Close modal on button click
              />
            )}
            {isModalOpenEdit && (
              <ReusableModal
                title="Edit Manager"
                content={
                  <>
                    <label>Name</label>

                    <div className="flex mt-2">
                      <input
                        type="text"
                        value={editManager?.name}
                        // placeholder="Enter Role Name"
                        className="w-full h-10 p-2.5 border-none rounded bg-gray-50"
                        onChange={(e) =>
                          handleRoleNameChange(e, "edit", "name")
                        }
                      />
                    </div>
                    <label>Mobile Number</label>

                    <div className="flex mt-2">
                      <input
                        type="text"
                        value={editManager?.mobileNumber}
                        // placeholder="Enter Role Name"
                        className="w-full h-10 p-2.5 border-none rounded bg-gray-50"
                        onChange={(e) =>
                          handleRoleNameChange(e, "edit", "mobileNumber")
                        }
                      />
                    </div>
                    <label>Email</label>

                    <div className="flex mt-2">
                      <input
                        type="text"
                        value={editManager?.email}
                        // placeholder="Enter Role Name"
                        className="w-full h-10 p-2.5 border-none rounded bg-gray-50"
                        onChange={(e) =>
                          handleRoleNameChange(e, "edit", "email")
                        }
                      />
                    </div>
                  </>
                }
                onUpload={() => addNewRole("edit")}
                ButtonValue="Update"
                onClose={closeModalEdit} // Close modal on button click
              />
            )}
          </div>
        </div>
      </div>

      <div className="w-full font-poppins mt-3 rounded-[10px] border-t pt-4 bg-white">
        <ReactTable
          key={JSON?.stringify(investorDetails)}
          defaultData={investorDetails}
          columns={columns}
        />
      </div>

      {investorDetails?.length > 0 && (
        <div className="w-auto mt-auto border-t">
          <CustomPagination
            currentPage={page}
            setCurrentPage={setPage}
            totalItems={total}
            itemsPerPage={10}
            maxPageNumbersToShow={5}
            storageKey="userManagementPage"
          />
        </div>
      )}
    </div>
  );
}

export default RelationshipManagerMain;
